import { Image, Text, View } from "@react-pdf/renderer";

export default function WOPdfHeader({
  locationLogo,
  logo,
  selectedWO,
  styles,
}) {
  /*   All States
   ********************************************* */

  /*   All Functions
   ********************************************* */
  const convertSqlTimestampToDate = (sqlTime) => {
    const timestamp = sqlTime;
    const date = new Date(timestamp);
    const time = date.toLocaleString("en-US", {
      year: "numeric",
      month: "numeric",
      day: "numeric",
    });
    return time.replaceAll("/", "-");
  };

  /*   All UseEffects
   ********************************************* */
  return (
    <>
      <View style={{ ...styles.topHeader, marginBottom: 10 }}>
        {/*   Top Header Section
         ********************************************* */}
        <View
          style={{
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "flex-start",
          }}
        >
          {/* <View style={{}}>
            {locationLogo ? (
              <Image
                src={locationLogo}
                style={{
                  width: 140,
                  height: 60,
                }}
              />
            ) : (
              <Image
                src={logo}
                style={{
                  width: 140,
                  height: 60,
                }}
              />
            )}
          </View> */}
          <View
            style={{
              flexGrow: 1,
              alignItems: "center",
              justifyContent: "center",
              textAlign: "center",
            }}
          >
            {/* <View>
              <Text style={[styles.headingSecond]}>
                Shipping Type: &nbsp;&nbsp;&nbsp;
                {selectedWO?.shippingMethod?.name || "N/A"}
              </Text>
              <Text style={[styles.headingSecond]}>
                In-Hand Date: &nbsp;&nbsp;&nbsp;
                {formatSqlDate({ sqlDate: selectedWO?.WoDueDate }) || "N/A"}
              </Text>
            </View> */}
          </View>
          <View
            style={{
              alignItems: "flex-end",
            }}
          >
            <Text style={[styles.headingMain, { marginBottom: 2 }]}>
              W-{selectedWO?.woId}
            </Text>
            <View
              style={{
                flexDirection: "column",
                justifyContent: "flex-end",
                alignItems: "flex-end",
              }}
            >
              <Text style={[styles.headingSecond]}>
                W-Date: &nbsp;&nbsp;&nbsp;
                {convertSqlTimestampToDate(selectedWO?.WODate)}
              </Text>
              <Text style={[styles.headingSecond]}>
                Print Date:&nbsp;&nbsp;&nbsp;
                {convertSqlTimestampToDate(Date.now())}
              </Text>
            </View>
          </View>
        </View>
      </View>
    </>
  );
}
